import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `Agenda`, method: 'GET', body: null})
}
